import Login from "./components/auth/login";
import Register from "./components/auth/register";
import Header from "./components/header";
import Form from "./components/form";
import Home from "./components/home";
import Instructions from "./components/instructions";
import Minigame from "./components/minigame";
import Profile from "./components/myprofile";
import Reset from "./components/auth/resetpassword";
import Change from "./components/auth/changepassword";
import Subscriptions from "./components/subscriptions/subscriptions"; // Import Subscriptions component
import { AuthProvider } from "./contexts/authContext";
import { useRoutes } from "react-router-dom";
import "./App.css";
import ProtectedRoute from "./protectedroute.js";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";



const publishableKey = `${process.env.REACT_APP_PUB_KEY}`; // Cast to string
const stripePromise = loadStripe(publishableKey); // Replace with your actual key

function App() {
    const routesArray = [
        {
            path: "/",
            element: <Home />,
        },
        {
            path: "/login",
            element: <Login />,
        },
        {
            path: "/register",
            element: <Register />,
        },
        {
            path: "/instructions",
            element: <Instructions />,
        },
        {
            path: "/minigame",
            element: <Minigame />,
        },
        {
            path: "/profile",
            element: <Profile />,
        },
        {
            path: "/reset",
            element: <Reset />,
        },
        {
            path: "/change",
            element: <Change />,
        },
        {
            path: "/bot",
            element: (
                <ProtectedRoute>
                    <Form />
                </ProtectedRoute>
            ),
        },
        {
            path: "/subscriptions", // Add the /subscriptions route
            element: (
                <Elements stripe={stripePromise}> {/* Wrap Subscriptions with Elements provider */}
                    <Subscriptions />
                </Elements>
            ),
        },
        {
            path: "*",
            element: <Login />,
        },
    ];

    let routesElement = useRoutes(routesArray);

    return (
        <AuthProvider>
            <Header />
            <div className="w-full h-screen flex flex-col">{routesElement}</div>
        </AuthProvider>
    );
}

export default App;